import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface WrapperProps {
    $hasFocus?: boolean;
    $showBackgroundWhenHasFocus?: boolean;
    $showMaskToFadeOverflow?: boolean;
}

export const TextInputWrapper = styled.div<WrapperProps>`
    display: flex;
    width: 100%;
    position: relative;

    ${({ $showMaskToFadeOverflow }) =>
        $showMaskToFadeOverflow &&
        css`
            mask: linear-gradient(to left, transparent, black 30px);
        `}

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        ${({ $showBackgroundWhenHasFocus, $hasFocus }) =>
            $showBackgroundWhenHasFocus &&
            css`
                &:before {
                    content: '';
                    position: absolute;
                    top: -4px;
                    right: -8px;
                    bottom: -4px;
                    left: -8px;
                    border-radius: 10px;
                    background: ${({ theme }) => theme.colors.white};
                    transition: opacity ${({ theme }) => theme.transitions.speeds.fast}s;
                    opacity: 0;
                    pointer-events: none;
                }

                &:hover:before {
                    opacity: 0.05;
                }

                ${$hasFocus &&
                css`
                    &:before {
                        opacity: 0.05;
                    }
                `}
            `}
    }

    *::selection {
        background: ${({ theme }) => theme.colors.purple};
    }
`;

interface CounterProps {
    $error?: boolean;
    $usesMouse?: boolean;
}

export const Counter = styled(motion.div)<CounterProps>`
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 24px;
    width: 34px;
    border: 1px solid ${({ theme }) => theme.colors.white};
    border-radius: 5px;
    box-shadow: 0 0 24px ${({ theme }) => theme.shades.black[85]};
    transition: border-color ${({ theme }) => theme.transitions.speeds.fast}s;

    ${({ $error }) =>
        $error &&
        css`
            border: 1px solid ${({ theme }) => theme.colors.red};
        `}

    ${({ $usesMouse }) =>
        $usesMouse
            ? css`
                  bottom: 35px;
                  right: 35px;
              `
            : css`
                  bottom: 10px;
                  right: 15px;
                  padding: 0 15px;
              `}
`;

const INPUT_BASE = css`
    background-color: transparent;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    width: 100%;
    cursor: text;
    font: inherit;
    color: inherit;
    caret-color: ${({ theme }) => theme.colors.purple};

    &:focus {
        border: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme.shades.white[20]};
    }
`;

export const StyledTextarea = styled.textarea`
    ${INPUT_BASE}
    resize: none;
    overflow: hidden;
`;

export const StyledInput = styled.input`
    ${INPUT_BASE}
`;
